module.exports = __webpack_public_path__ + "img/tr.bbb2dc73.svg";